/**
 * @generated SignedSource<<d0d8e06e40249fa30adca6434e21324d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type DocumentType = "COF_C" | "QC_TEST_CERT" | "%future added value";
export type AllDocumentsModalQuery$variables = {
  instrumentId: string;
};
export type AllDocumentsModalQuery$data = {
  readonly allDocumentsForInstrument: ReadonlyArray<{
    readonly documentType?: DocumentType | null | undefined;
    readonly fileName?: string | null | undefined;
  }>;
};
export type AllDocumentsModalQuery = {
  response: AllDocumentsModalQuery$data;
  variables: AllDocumentsModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "instrumentId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "instrumentId",
    "variableName": "instrumentId"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "documentType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fileName",
      "storageKey": null
    }
  ],
  "type": "GetAllDocumentsForInstrument_AllDocumentsForInstrument_Document",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AllDocumentsModalQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "allDocumentsForInstrument",
        "plural": true,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AllDocumentsModalQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "allDocumentsForInstrument",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "778c4d8182d503f2462b99165a15b16d",
    "id": null,
    "metadata": {},
    "name": "AllDocumentsModalQuery",
    "operationKind": "query",
    "text": "query AllDocumentsModalQuery(\n  $instrumentId: String!\n) {\n  allDocumentsForInstrument(instrumentId: $instrumentId) {\n    __typename\n    ... on GetAllDocumentsForInstrument_AllDocumentsForInstrument_Document {\n      documentType\n      fileName\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5051f250ff4858082389fbb02757161d";

export default node;
